export interface SetCampaignIdAction {
  type: "SET_CAMPAIGN_ID";
  data: string;
}

export function setCampaignId(campaignId: string): SetCampaignIdAction {
  return {
    type: "SET_CAMPAIGN_ID",
    data: campaignId,
  };
}
